export default __webpack_public_path__ + "src/assets/cdai-mobile.6114e7bba631d443387221a6438b2e41.svg";